/**
 * Call to Action - Create Activity
 * --------------------------------
 *
 * Expected variables:
 * - activityGroupId
 */

import View from 'view/view'
import template from 'component/cta/create_activity/template.tmpl'
import Router from 'service/router'
import assets from 'service/assets'

const CreateActivityView = View.extend({
    template,
    render() {
        this.$el.html(
            this.template({
                img: assets.getStaticImageUrl('/ui/empty-states/no-contacts-v1.svg'),
                link: {
                    createActivity: Router.path(
                        'activity_group_activity_new',
                        { activityGroupId: this.options.activityGroupId },
                        { query: { ref: 'gra_ua_fc' } }
                    ),
                },
            })
        )

        return this
    },
})

export default CreateActivityView
